// extracted by mini-css-extract-plugin
export default {"menu":"DropdownMenu_menu__EDexm"};